import { PostPayload } from "@/app/api/types";
import { Entity, IField } from "@/app/fields/types";

export const cleanPayload = <T extends Entity>(
  _payload: PostPayload<T>,
  fields: IField<T>[]
): PostPayload<T> => {
  const payload = { ..._payload };
  fields.forEach(({ type, field }) => {
    if (type === "number") {
      // "The number field value is always a string, you have to parse it yourself."
      const numberString = ((_payload[field] as string) || "").replaceAll(
        ",",
        ""
      );
      const parsed = parseInt(numberString);
      if (numberString !== "" && !isNaN(parsed)) {
        payload[field] = parsed;
      } else {
        // todo: test able to set to null
        payload[field] = null;
      }
    } else if (type === "text") {
      // remove empty strings (set to undefined)
      payload[field] = (_payload[field] as string) || null;
    } else if (type === "boolean") {
      // for some reason false values come out as undefined
      payload[field] = !!(_payload[field] as boolean | null);
    }
  });
  return payload;
};
